export default __webpack_public_path__ + "static/studionft-top-20f18207ec373605b9869f58f5eebd9f.jpg";